//import axios from "axios";
import { QueryFunctionContext } from '@tanstack/react-query';
import { MeasurementReport, PatientStudyInfo } from "./type";

let lastResults : { 
  lastReportQuery: MeasurementReport[] | null, 
} = {lastReportQuery : null};

export const getReportLists = async (context: QueryFunctionContext): Promise<MeasurementReport[]> => {
  //const res = await axios.get("https://jsonplaceholder.typicode.com/posts");
  //return res.data;

  performance.mark('report_data_begin');
  let reportLists = new Array<MeasurementReport>();
  let patients = new Array<PatientStudyInfo>();
  [...Array(context.meta?.numPatients).keys()].forEach(elem => {
    let pat : PatientStudyInfo = {
      patientID: 'PAT'+elem,
      patientsName: 'Name'+elem,
      patientSex: 'Male',
      patientDOB: '',
      studyID: 'STD'+elem,
      studyInsUID: ''+elem,
      studyDateTime: '2025/04/01',
      relatedReportUIDs: []
    };
    patients.push(pat);
  });

  [...Array(context.meta?.numReports).keys()].forEach(elem => {
    const patPickInd = (elem+0.1)/(context.meta?.numReports as number)*patients.length;
    const patient = patients[Math.floor(patPickInd)];
    let report : MeasurementReport = {
      reportUID: 'RP'+elem,
      reportDate: '2025/04/01',
      studyInsUID: patient.studyInsUID,
      studyDateTime: '2025/04/01',
      patientID: patient.patientID,
      patientsName: patient.patientsName,
      appCode: '1',
      subAppCode: '1',
      patientStudyInfo: patient,
    };    
    reportLists.push(report);
  });
  performance.mark('report_data_end');
  performance.measure(
    'report_data',
    'report_data_begin',
    'report_data_end',
  );
  const perfMeas = performance.getEntriesByName('report_data');
  console.log('reportlist generation times (ms)' + perfMeas[0].duration);

  lastResults.lastReportQuery = reportLists;
  return Promise.resolve(reportLists);
};

